import {
  InventoryTypeId,
  InventoryTypeKey,
  type VehicleTag
} from '@carvana/merch-contracts';
import TagIds from '~/constants/common/tagIds';
import getPurchaseStatus from '~/utilities/getPurchaseStatus';
import { StatusTagEnum } from './StatusTag';

type OwnProps = {
  isLockedByCurrentUser?: boolean;
  saleStatus?: string;
  vehicleInventoryType: InventoryTypeId | InventoryTypeKey;
  vehicleTags?: VehicleTag[];
  vehicleUnlockDateTime?: string;
};

export default function getVehicleStatus({
  isLockedByCurrentUser,
  saleStatus,
  vehicleInventoryType,
  vehicleTags = [],
  vehicleUnlockDateTime
}: OwnProps): StatusTagEnum | null {
  const { isLocked, isOnHold } = getPurchaseStatus({ vehicleUnlockDateTime });
  const isPreOrder =
    vehicleInventoryType === InventoryTypeId.WIP ||
    vehicleInventoryType === InventoryTypeKey.WIP;
  const showRecentlyAdded = vehicleTags.some(
    tag => tag.tagId === TagIds.RecentlyAdded
  );
  const isUnavailableVehicle =
    saleStatus?.toLowerCase() === StatusTagEnum.Unavailable;
  const isSoldVehicle = saleStatus?.toLowerCase() === StatusTagEnum.Sold;

  switch (true) {
    case isUnavailableVehicle:
      return StatusTagEnum.Unavailable;
    case isSoldVehicle:
      return StatusTagEnum.Sold;
    case isOnHold:
      return StatusTagEnum.Hold;
    case isLocked:
      return isPreOrder && isLockedByCurrentUser
        ? StatusTagEnum.PreOrdered
        : StatusTagEnum.Locked;
    case isPreOrder:
      return StatusTagEnum.Reservable;
    case showRecentlyAdded:
      return StatusTagEnum.Recent;
    default:
      return null;
  }
}
